





































































































import Vue from 'vue';
import { Type, WhileExpression, Expression, NoExpression, BooleanType, ChainExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<WhileExpression>().extend({
  name: 'WhileEditor',
  data: () => ({
    configuring: false,
  }),
  computed: {
    bodyContext(): Type {
      return this.registry.defs.getContext(this.context, this.value.getScope());
    },
    configureLabel(): string {
      return this.configuring
        ? 'Hide While Options'
        : 'Show While Options';
    },
    hasChain(): boolean {
      return this.value.body instanceof ChainExpression;
    },
  },
  methods: {
    updateCondition(condition?: Expression) {
      this.value.condition = condition || NoExpression.instance;
      this.update();
    },
    updateBody(body?: Expression) {
      this.value.body = body || NoExpression.instance;
      this.update();
    },
    toggleConfigure() {
      this.configuring = !this.configuring;
    },
  },
});
